import EnvUtil from "../common/util/EnvUtil";
import ScrollUtil from "../common/util/ScrollUtil";
import Fader from "../common/view/Fader";
import Graph from "../result/Graph";
import IssueView from "./IssueView";

class Top {
  // ---------------------------------------------------------------------------------------------------------
  // --	Top
  // ---------------------------------------------------------------------------------------------------------

  constructor() {
    console.log("Top");

    //フェーダー
    this.fader = new Fader();

    //グラフ
    this.graph = new Graph();

    //課題のクラスか
    const holder = this;
    this.issues = [];
    $(".pg-top__issue-item").each(function () {
      const issue = new IssueView($(this));
      holder.issues.push(issue);
    });

    //STARTボタンのアクション
    $(".js-start-btn").on("click", this.onQuizStart.bind(this));

    const $startBtn = $(".js-attention-anim");
    gsap.to($startBtn, 1.0, {
      scaleX: 1.06,
      scaleY: 1.06,
      ease: "power2.out",
      yoyo: true,
      repeat: -1,
    });

    //スタート
    this.start();
  }

  /**
   * スタート
   */
  start() {
    //フェードイン
    this.fader.hide(() => {
      //グラフのアニメーション開始
      this.graph.startRandomMove();

      //スクロールのハンドリング開始
      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener("scroll", this.onScrollHandler);
      this.onScroll();
    });
  }

  // ---------------------------------------------------------------------------------------------------------
  // --	SCROLL
  // ---------------------------------------------------------------------------------------------------------

  onScroll() {
    //SPの時はひとつづつ
    if (EnvUtil.isSP()) {
      let inViewCount = 0;
      this.issues.forEach((issue) => {
        if (issue.isInView()) {
          inViewCount++;
          issue.enter();
        }
      });
      if (inViewCount >= 6) {
        window.removeEventListener("scroll", this.onScrollHandler);
      }
    }
    //PCの時はいっきに
    else {
      if (this.issues[this.issues.length - 1].isInView()) {
        this.issues[0].enter(0);
        this.issues[1].enter(0.3);
        this.issues[3].enter(0.6);
        this.issues[2].enter(0.9);
        this.issues[4].enter(1.2);
        this.issues[5].enter(1.5);
        window.removeEventListener("scroll", this.onScrollHandler);
      }
    }
  }

  // ---------------------------------------------------------------------------------------------------------
  // --	INPUT
  // ---------------------------------------------------------------------------------------------------------

  /**
   * クイズスタート
   */
  onQuizStart(e) {
    this.fader.changeCategory("cat1");
    this.fader.show(() => {
      location.href = "quiz.html";
    });
    return false;
  }

  // ---------------------------------------------------------------------------------------------------------
}

export default Top;
